<dcr-breadcrumb-group [separator]="separator">
  @for (breadcrumb of dcrBreadcrumbs; track breadcrumb) {
    <dcr-breadcrumb
      [label]="breadcrumb.label"
      [href]="breadcrumb.href"
      [current]="breadcrumb.current"
      (click)="breadcrumbClick($event, breadcrumb)"
      >
    </dcr-breadcrumb>
  }
</dcr-breadcrumb-group>
